import Box from "@mui/material/Box"
import { AccountModel, truncateEmail, truncateText, Typography } from "@cakemail-org/ui-components-v2"
import { useTranslation } from "react-i18next"
import "./styles.scss"
import { TNameTableCol } from "./types"
import { Tooltip } from "@mui/material"

export function NameTableCol({ name, desc, imgSrc, sizeX, sizeY, asBGImg, truncateNameSize, truncateDescSize, extra, ellipsis, imgMatchString }: TNameTableCol) {
    const { t, i18n } = useTranslation()
    const ellipsisClass = ellipsis ? "ellipsis" : ""

    let truncatedName = name

    if (name) {
        if (name?.includes("@")) {
            truncatedName = truncateEmail(name, truncateNameSize || 55)
        } else {
            truncatedName = truncateText(name, truncateNameSize || 55)
        }
    }

    imgMatchString = imgMatchString || "/200/110/"

    return <Box className="nameTableCol">
        {imgSrc &&
            <>
                {asBGImg ?
                    <div className="img" style={{ backgroundImage: `url("${imgSrc.replace(imgMatchString, `/${sizeX || 90}/${sizeY || 120}`)}"/` }}></div>
                    :
                    <img src={imgSrc.replace(imgMatchString, `/${sizeX || 90}/${sizeY || 120}/`)} />
                }
            </>
        }
        <Box>
            {truncatedName &&
                <Tooltip title={name}>
                    <Box><Typography variant="body1L" className={"semiBold "}>{truncatedName}</Typography></Box>
                </Tooltip>
            }
            {desc &&
                <Typography variant="body2L" className={ellipsisClass + " regular"} >{truncateText(desc, truncateDescSize || 300)}</Typography>
            }

            {extra && <Box>{extra}</Box>}
        </Box>
    </Box>
}
